import { defineMessages } from 'react-intl';

export default defineMessages({
  phase1: 'Locked Assets',
  phase2: 'Phase 2 - Locked LP Tokens',
  depositButton: 'Deposit Now',
  approve: 'Approve',
});
